module.exports = __webpack_public_path__ + "img/bg12.c44f7e68.png";